import React from 'react';

const PageNotFound = () => {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'Black',
      }}
    >
      <img src="https://http.cat/404" alt="not found" />
      <div id="info">{/* <h3>This page could not be found</h3> */}</div>
    </div>
  );
};

export default PageNotFound;
